(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aec-alu-cab-landing"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-aec-alu-selector]');
  if (!root) return;
  const make = root.querySelector('[data-aec-make]');
  const model = root.querySelector('[data-aec-model]');
  const options = [...model.querySelectorAll('option[data-make]')];
  const matchBox = document.querySelector('[data-aec-fitment-match]');
  const matchInput = document.querySelector('[data-aec-fitment-match-input]');
  const quoteForm = document.querySelector('.aec-alu__quote-form');
  const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  const pageParams = new URLSearchParams(window.location.search);
  const previewMode = pageParams.get('view') === 'aec-alu-cab';
  const catalogue = [
    { make: 'BYD', model: 'Shark 6', from: 2024, to: 2030, cab: { 'Dual Cab': [{ label: 'Explorer from $4,539', handle: 'alu-cab-explorer-canopy-byd-shark-6' }, { label: 'Contour from $5,809', handle: 'alu-cab-contour-canopy-byd-shark-6' }] } },
    { make: 'GWM', model: 'Cannon', from: 2000, to: 2030, cab: { 'Dual Cab': [{ label: 'Explorer from $4,539', handle: 'alu-cab-explorer-canopy-gwm-cannon' }] } },
    { make: 'Ford', model: 'Ranger Next-Gen (2022+)', from: 2022, to: 2030, cab: { 'Dual Cab': [{ label: 'Explorer from $4,249', handle: 'alu-cab-explorer-canopy-ford-next-gen-ranger' }, { label: 'Contour from $5,809', handle: 'alu-cab-contour-canopy-ford-next-gen-ranger' }], 'Extra Cab': [{ label: 'Contour from $7,069', handle: 'alu-cab-contour-canopy-ford-next-gen-ranger' }], 'Single Cab': [{ label: 'Explorer from $6,769', handle: 'alu-cab-explorer-canopy-ford-next-gen-ranger' }] } },
    { make: 'Ford', model: 'Ranger PX', from: 2012, to: 2019, cab: { 'Dual Cab': [{ label: 'Explorer from $4,249', handle: 'alu-cab-explorer-canopy-ford-ranger-px-mazda-bt-50-2012-2019' }, { label: 'Contour from $5,809', handle: 'alu-cab-contour-canopy-ford-ranger-px-mazda-bt-50-2012-2019' }], 'Extra Cab': [{ label: 'Explorer from $5,159', handle: 'alu-cab-explorer-canopy-ford-ranger-px-mazda-bt-50-2012-2019' }, { label: 'Contour from $6,349', handle: 'alu-cab-contour-canopy-ford-ranger-px-mazda-bt-50-2012-2019' }], 'Single Cab': [{ label: 'Explorer from $5,879', handle: 'alu-cab-explorer-canopy-ford-ranger-px-mazda-bt-50-2012-2019' }] } },
    { make: 'Holden', model: 'Colorado', from: 2012, to: 2019, cab: { 'Dual Cab': [{ label: 'Explorer from $4,249', handle: 'alu-cab-explorer-canopy-isuzu-d-max-holden-colorado-2012-2019' }], 'Extra Cab': [{ label: 'Explorer from $5,159', handle: 'alu-cab-explorer-canopy-isuzu-d-max-holden-colorado-2012-2019' }] } },
    { make: 'Isuzu', model: 'D-MAX', from: 2012, to: 2019, cab: { 'Dual Cab': [{ label: 'Explorer from $4,249', handle: 'alu-cab-explorer-canopy-isuzu-d-max-holden-colorado-2012-2019' }], 'Extra Cab': [{ label: 'Explorer from $5,159', handle: 'alu-cab-explorer-canopy-isuzu-d-max-holden-colorado-2012-2019' }] } },
    { make: 'Isuzu', model: 'D-MAX', from: 2020, to: 2024, cab: { 'Dual Cab': [{ label: 'Explorer from $4,249', handle: 'alu-cab-explorer-canopy-d-max-bt-50-2020' }, { label: 'Contour from $5,809', handle: 'alu-cab-contour-canopy-d-max-bt-50-2020' }], 'Extra Cab': [{ label: 'Explorer from $5,159', handle: 'alu-cab-explorer-canopy-d-max-bt-50-2020' }] } },
    { make: 'Isuzu', model: 'D-MAX', from: 2025, to: 2030, cab: { 'Dual Cab': [{ label: 'Explorer from $4,249', handle: 'alu-cab-explorer-canopy-d-max-bt-50-2020' }, { label: 'Contour from $5,809', handle: 'alu-cab-contour-canopy-d-max-bt-50-2020' }] } },
    { make: 'Jeep', model: 'Gladiator', from: 2019, to: 2030, cab: { 'Dual Cab': [{ label: 'Explorer from $4,539', handle: 'alu-cab-explorer-canopy-jeep-gladiator' }, { label: 'Contour from $5,809', handle: 'alu-cab-contour-canopy-jeep-gladiator' }] } },
    { make: 'Mercedes-Benz', model: 'X-Class', from: 2016, to: 2030, cab: { 'Dual Cab': [{ label: 'Explorer from $4,799', handle: 'alu-cab-explorer-canopy-mercedes-benz-x-class' }] } },
    { make: 'Mazda', model: 'BT-50', from: 2012, to: 2019, cab: { 'Dual Cab': [{ label: 'Explorer from $4,249', handle: 'alu-cab-explorer-canopy-ford-ranger-px-mazda-bt-50-2012-2019' }, { label: 'Contour from $5,809', handle: 'alu-cab-contour-canopy-ford-ranger-px-mazda-bt-50-2012-2019' }], 'Extra Cab': [{ label: 'Explorer from $5,159', handle: 'alu-cab-explorer-canopy-ford-ranger-px-mazda-bt-50-2012-2019' }, { label: 'Contour from $6,349', handle: 'alu-cab-contour-canopy-ford-ranger-px-mazda-bt-50-2012-2019' }], 'Single Cab': [{ label: 'Explorer from $5,879', handle: 'alu-cab-explorer-canopy-ford-ranger-px-mazda-bt-50-2012-2019' }] } },
    { make: 'Mazda', model: 'BT-50', from: 2020, to: 2024, cab: { 'Dual Cab': [{ label: 'Explorer from $4,249', handle: 'alu-cab-explorer-canopy-d-max-bt-50-2020' }, { label: 'Contour from $5,809', handle: 'alu-cab-contour-canopy-d-max-bt-50-2020' }], 'Extra Cab': [{ label: 'Explorer from $5,159', handle: 'alu-cab-explorer-canopy-d-max-bt-50-2020' }] } },
    { make: 'Mazda', model: 'BT-50', from: 2025, to: 2030, cab: { 'Dual Cab': [{ label: 'Explorer from $4,249', handle: 'alu-cab-explorer-canopy-d-max-bt-50-2020' }, { label: 'Contour from $5,809', handle: 'alu-cab-contour-canopy-d-max-bt-50-2020' }] } },
    { make: 'Mitsubishi', model: 'Triton', from: 2016, to: 2023, cab: { 'Dual Cab': [{ label: 'Explorer from $4,539', handle: 'alu-cab-explorer-canopy-mitsubishi-triton-mq-mr' }, { label: 'Contour from $5,809', handle: 'alu-cab-contour-canopy-mitsubishi-triton-mq-mr' }], 'Extra Cab': [{ label: 'Explorer from $5,159', handle: 'alu-cab-explorer-canopy-mitsubishi-triton-mq-mr' }] } },
    { make: 'Mitsubishi', model: 'Triton', from: 2024, to: 2030, cab: { 'Dual Cab': [{ label: 'Contour from $5,809', handle: 'alu-cab-contour-canopy-mitsubishi-triton-mv-2024' }] } },
    { make: 'Nissan', model: 'Navara D40', from: 2005, to: 2015, cab: { 'Dual Cab': [{ label: 'Explorer from $4,539', handle: 'alu-cab-explorer-canopy-nissan-navara-d40' }], 'Extra Cab': [{ label: 'Explorer from $5,159', handle: 'alu-cab-explorer-canopy-nissan-navara-d40' }] } },
    { make: 'Nissan', model: 'Navara NP300', from: 2016, to: 2020, cab: { 'Dual Cab': [{ label: 'Explorer from $4,539', handle: 'alu-cab-explorer-canopy-nissan-navara-np300-2016-2020' }, { label: 'Contour from $5,809', handle: 'alu-cab-contour-canopy-nissan-navara-np300-2016-2020' }], 'Extra Cab': [{ label: 'Explorer from $5,159', handle: 'alu-cab-explorer-canopy-nissan-navara-np300-2016-2020' }] } },
    { make: 'Nissan', model: 'Navara NP300', from: 2021, to: 2025, cab: { 'Dual Cab': [{ label: 'Explorer from $4,539', handle: 'alu-cab-explorer-canopy-nissan-navara-np300-2021-2025' }, { label: 'Contour from $5,809', handle: 'alu-cab-contour-canopy-nissan-navara-np300-2021-2025' }] } },
    { make: 'Toyota', model: 'HiLux N70', from: 2005, to: 2015, cab: { 'Dual Cab': [{ label: 'Explorer from $4,539', handle: 'alu-cab-explorer-canopy-toyota-hilux-n70-2005-2015' }], 'Extra Cab': [{ label: 'Explorer from $5,159', handle: 'alu-cab-explorer-canopy-toyota-hilux-n70-2005-2015' }] } },
    { make: 'Toyota', model: 'HiLux N80', from: 2016, to: 2025, cab: { 'Dual Cab': [{ label: 'Explorer from $4,249', handle: 'alu-cab-explorer-canopy-toyota-hilux-n80' }, { label: 'Contour from $5,809', handle: 'alu-cab-contour-canopy-toyota-hilux-n80' }], 'Extra Cab': [{ label: 'Explorer from $4,849', handle: 'alu-cab-explorer-canopy-toyota-hilux-n80' }, { label: 'Contour from $6,349', handle: 'alu-cab-contour-canopy-toyota-hilux-n80' }], 'Single Cab': [{ label: 'Explorer from $5,879', handle: 'alu-cab-explorer-canopy-toyota-hilux-n80' }] } },
    { make: 'Toyota', model: 'HiLux N90', from: 2026, to: 2030, cab: { 'Dual Cab': [{ label: 'Explorer from $4,249', handle: 'alu-cab-explorer-canopy-toyota-hilux-n90-2026' }, { label: 'Contour from $5,809', handle: 'alu-cab-contour-canopy-toyota-hilux-n90-2026' }] } },
    { make: 'Toyota', model: 'LandCruiser 79 Series', from: 2007, to: 2030, cab: { 'Dual Cab': [{ label: 'Explorer from $6,059', handle: 'alu-cab-explorer-canopy-toyota-landcruiser-79-series' }], 'Single Cab': [{ label: 'Explorer from $7,649', handle: 'alu-cab-explorer-canopy-toyota-landcruiser-79-series' }] } },
    { make: 'Volkswagen', model: 'Amarok', from: 2010, to: 2022, cab: { 'Dual Cab': [{ label: 'Explorer from $4,539', handle: 'alu-cab-explorer-canopy-volkswagen-amarok-2010-2022' }, { label: 'Contour from $5,809', handle: 'alu-cab-contour-canopy-volkswagen-amarok-2010-2022' }] } },
    { make: 'Volkswagen', model: 'Amarok', from: 2023, to: 2030, cab: { 'Dual Cab': [{ label: 'Explorer from $5,329', handle: 'alu-cab-explorer-canopy-volkswagen-amarok-2023' }, { label: 'Contour from $5,809', handle: 'alu-cab-contour-canopy-volkswagen-amarok-2023' }] } },
    { make: 'RAM', model: '1500', from: 2009, to: 2030, cab: { 'Short Bed': [{ label: 'Contour from $7,989', handle: 'alu-cab-contour-canopy-ram-1500-2009' }] } },
    { make: 'RAM', model: '2500 / 3500', from: 2009, to: 2030, cab: { 'Short Bed': [{ label: 'Contour from $8,719', handle: 'alu-cab-contour-canopy-ram-2500-3500-2009' }] } },
    { make: 'Ford', model: 'F-150', from: 2015, to: 2020, cab: { 'Short Bed': [{ label: 'Contour from $7,989', handle: 'alu-cab-contour-canopy-ford-f-150-8th-gen-2015-2020' }], 'Full Bed': [{ label: 'Contour from $8,719', handle: 'alu-cab-contour-canopy-ford-f-150-8th-gen-2015-2020' }] } },
    { make: 'Ford', model: 'F-150', from: 2021, to: 2030, cab: { 'Short Bed': [{ label: 'Contour from $7,989', handle: 'alu-cab-contour-canopy-ford-f-150-9th-gen-2021' }], 'Full Bed': [{ label: 'Contour from $8,719', handle: 'alu-cab-contour-canopy-ford-f-150-9th-gen-2021' }] } },
    { make: 'Toyota', model: 'Tundra', from: 2022, to: 2030, cab: { 'Short Bed': [{ label: 'Contour from $5,809', handle: 'alu-cab-contour-canopy-toyota-tundra-2022' }], 'Full Bed': [{ label: 'Contour from $6,339', handle: 'alu-cab-contour-canopy-toyota-tundra-2022' }] } },
  ];
  const syncModels = () => {
    model.value = '';
    options.forEach((option) => { option.hidden = option.dataset.make !== make.value; });
    model.disabled = !make.value;
  };
  make.addEventListener('change', syncModels);
  root.addEventListener('submit', (event) => {
    event.preventDefault();
    const year = Number(root.querySelector('[name="vehicle_year"]').value);
    const cab = root.querySelector('[name="cab_type"]').value;
    const vehicle = document.querySelector('[data-aec-quote-vehicle]');
    const cabField = document.querySelector('[data-aec-quote-cab]');
    const record = catalogue.find((item) => item.make === make.value && item.model === model.value && year >= item.from && year <= item.to);
    const ranges = record?.cab?.[cab] || [];
    const rangeLabels = ranges.map((item) => item.label);
    const handles = [...new Set(ranges.map((item) => item.handle))];
    const vehicleSummary = `${make.value} ${model.value} ${year}`.trim();
    const matchSummary = ranges.length
      ? `${vehicleSummary} · ${cab} · ${rangeLabels.join(' · ')} · Product handles: ${handles.join(', ')}`
      : `${vehicleSummary} · ${cab} · Manual AEC fitment review required`;
    if (vehicle) vehicle.value = vehicleSummary;
    if (cabField) cabField.value = cab;
    const matchField = document.querySelector('[data-aec-fitment-match-input]');
    if (matchField) {
      matchField.value = matchSummary;
      matchField.setAttribute('value', matchSummary);
    }
    if (matchBox) {
      matchBox.hidden = false;
      matchBox.querySelector('strong').textContent = ranges.length ? 'Current catalogue match' : 'AEC fitment review required';
      matchBox.querySelector('span').textContent = ranges.length
        ? `${rangeLabels.join(' · ')}. Final price, stock, freight and installation are confirmed by AEC.`
        : 'This configuration is not yet mapped to a verified draft SKU. AEC will check it manually before quoting.';
      const linkWrap = matchBox.querySelector('[data-aec-fitment-links]');
      if (linkWrap) {
        linkWrap.replaceChildren();
        if (ranges.length) {
          ranges.forEach((item) => {
            const link = document.createElement('a');
            if (previewMode) {
              link.href = '#AluCabQuoteForm';
              link.textContent = `REQUEST ${item.label.split(' from ')[0].toUpperCase()} CONFIGURATION →`;
            } else {
              link.href = `/products/${item.handle}`;
              link.textContent = `VIEW ${item.label.split(' from ')[0].toUpperCase()} CONFIGURATION →`;
            }
            linkWrap.appendChild(link);
          });
        } else {
          const compareLink = document.createElement('a');
          compareLink.href = '/pages/alu-cab-canopy-comparison';
          compareLink.textContent = 'COMPARE EXPLORER & CONTOUR →';
          linkWrap.appendChild(compareLink);
        }
      }
    }
    document.querySelector('#fitment-quote')?.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    matchBox?.focus({ preventScroll: true });
  });
  quoteForm?.addEventListener('submit', () => {
    if (!matchInput || matchInput.value) return;
    const vehicleValue = quoteForm.querySelector('[data-aec-quote-vehicle]')?.value.trim() || 'Vehicle not supplied';
    const cabValue = quoteForm.querySelector('[data-aec-quote-cab]')?.value.trim() || 'Cab / tub not supplied';
    const manualSummary = `${vehicleValue} · ${cabValue} · Manual AEC fitment review required`;
    matchInput.value = manualSummary;
    matchInput.setAttribute('value', manualSummary);
  });
  const presetMake = pageParams.get('vehicle_make');
  const presetModel = pageParams.get('vehicle_model');
  const presetYear = pageParams.get('vehicle_year');
  const presetCab = pageParams.get('cab_type');
  if (presetMake) {
    make.value = presetMake;
    syncModels();
    if (presetModel) model.value = presetModel;
    if (presetYear) root.querySelector('[name="vehicle_year"]').value = presetYear;
    if (presetCab) root.querySelector('[name="cab_type"]').value = presetCab;
    if (make.value && model.value && presetYear && presetCab) {
      window.requestAnimationFrame(() => root.requestSubmit());
    }
  } else {
    syncModels();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
